export default {
    bulk_tags_title: "Asignar etiquetas masivas",
    bulk_tags_label: "Etiqueta",
    bulk_tags_input: "IMEI o serie",
    bulk_tags_imei: "IMEI",
    bulk_tags_serial: "Serie",
    bulk_tags_model: "Modelo",
    bulk_tags_assign: "Asignar",
    bulk_tags_device_is_already_added: "El dispositivo ya está añadido",
    bulk_tags_device_has_not_been_found: "No se ha encontrado el dispositivo",
    bulk_tags_multiple_success_message: "Se ha actualizado la cuenta del proveedor de Sim de los dispositivos",
    bulk_tags_error_message: "No se ha podido asignar las etiquetas debido a un error",
    bulk_tags_company_name: "Nombre",
    bulk_tags_input_company_name: "Nombre de la compañía",
    bulk_tags_company_is_already_added: "La cuenta ya está añadida",
    bulk_tags_company_has_not_been_found: "No se ha encontrado la cuenta",
    bulk_tags_unassign: "Desasignar",
}